import { DocFlowAttachFilesButton } from '../../DocFlowAttachFilesButton'
import { DocFlowProfileHeaderActionsBase } from '../DocFlowProfileHeaderActionsBase'

import { isAttachFilesButtonDisabled } from './DocFlowProfileHeaderActionsUploading.utils'

function DocFlowProfileHeaderActionsUploading(props) {
  const {
    attachDisabled,
    completedPhase,
    files,
    totalFilesCount,
    ...restProps
  } = props

  const attachFilesButtonDisabled = isAttachFilesButtonDisabled(
    attachDisabled,
    completedPhase
  )

  return (
    <DocFlowProfileHeaderActionsBase
      {...restProps}
      completedPhase={completedPhase}
    >
      <DocFlowAttachFilesButton
        disabled={attachFilesButtonDisabled}
        files={files}
        totalFilesCount={totalFilesCount}
        onFinishUpload={props.onFinishUpload}
        onSetFiles={props.onSetFiles}
        onStartUpload={props.onStartUpload}
        onUploadErrors={props.onUploadErrors}
      />
    </DocFlowProfileHeaderActionsBase>
  )
}

export default DocFlowProfileHeaderActionsUploading
